import { render, staticRenderFns } from "./dictamen-reconsideracion.vue?vue&type=template&id=24c415de&scoped=true&"
import script from "./dictamen-reconsideracion.component.ts?vue&type=script&lang=ts&"
export * from "./dictamen-reconsideracion.component.ts?vue&type=script&lang=ts&"
import style0 from "./dictamen-reconsideracion.vue?vue&type=style&index=0&id=24c415de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c415de",
  null
  
)

export default component.exports